import React from 'react';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { Tooltip, Button, Icon, Checkbox } from 'antd';
import { RetweetOutlined, MinusCircleOutlined, DisconnectOutlined, EditOutlined } from '@ant-design/icons'
import ConceptCount from '../widgets/ConceptCount';

const isConceptHighlighted = (concept, highlight) => {
  return Array.isArray(highlight) && highlight.includes(concept?.IRI?.value);
};

/** Концепт в виде строки  */
class ConceptSingleBase extends React.Component {	

  detailWasOpened = false;

  onCountUsed(e){
    const {concept, handlers} = this.props; 
    handlers(e, concept, "used");
  }; 
  
  openDetailIfHighlighted() {
    const { concept, handlers, highlight } = this.props;

    if (isConceptHighlighted(concept, highlight) && !this.detailWasOpened) {
      this.detailWasOpened = true;
      handlers({ stopPropagation: () => {}, preventDefault: () => {}},concept,"detail");
    }
  }

  componentDidMount() {
    this.openDetailIfHighlighted();
  }

  componentDidUpdate(prevProps) {
    const prevIRI = prevProps.concept?.IRI?.value;
    const currentIRI = this.props.concept?.IRI?.value;

    const prevHighlight = prevProps.highlight;
    const currentHighlight = this.props.highlight;

    if (prevIRI !== currentIRI || prevHighlight !== currentHighlight) {
      this.openDetailIfHighlighted();
    }
  }

  render(){
    //console.log(this);
    const {hideStatistics, concept, handlers, operation, highlight} = this.props; 
    const isHighlighted = isConceptHighlighted(concept, highlight);
    return (
      <span>
        <span style={isHighlighted ? { backgroundColor: "#fff3cd", padding: "2px 4px", borderRadius: 4, fontWeight: 600}: undefined}>
          <a
            href={`#/subject/${encodeURIComponent(concept.IRI.value || "")}`}
            target="_blank"
            rel="noopener noreferrer"
            title={i18n.t('components.skos.conceptSmall.details')}
          >
            {concept.Label.value}
          </a>
        </span>&nbsp;{!hideStatistics &&<ConceptCount IRI={concept.IRI.value} handlers={(e)=> handlers(e, concept, "used")}/>}&nbsp;
        {/* <Button icon={<InfoOutlined style={{ padding: "0 0 0 0"}} />} shape="circle" size="small" 
          onClick={(e)=>handlers(e, concept, "detail")} /> */}
        {operation == "edit" &&
          <>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.deleteConcept')}>
              <Button type="dashed" size="small" icon={<MinusCircleOutlined />} 
                onClick={(e)=> handlers(e, concept, "delete")}
                style={{"float":"right"}}/>
            </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.unlinkFromScheme')}>
              <Button type="dashed" size="small" icon={<DisconnectOutlined />} 
                onClick={(e)=> handlers(e, concept, "unlink")}
                style={{"float":"right"}}/>
            </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.replaceWithConcept')}>
                <Button type="dashed" size="small" icon={<RetweetOutlined />} 
                  onClick={(e)=> handlers(e, concept, "replacement")}
                  style={{"float":"right"}}/>
              </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.editConcept')}>
              <Button type="dashed" size="small" icon={<EditOutlined />} 
                onClick={(e)=> handlers(e, concept, "edit")}
                style={{"float":"right"}}/>
            </Tooltip>
          </>
        }
      </span>
    )    
  };
}

export const ConceptSingle = connect(
  (state, props) => {
    const { vset } = state;
    const {lang, graph} = props;
    return {
        lang: (lang)?lang: vset.lang,
        graph: (graph)?graph: vset.graph,
    };
  }
)(ConceptSingleBase);


/** Концепт в виде заголовка панели  */
class ConceptPanelBase extends React.Component {	

  detailWasOpened = false;
  
  openDetailIfHighlighted() {
    const { concept, handlers, highlight } = this.props;

    if (isConceptHighlighted(concept, highlight) && !this.detailWasOpened) {
      this.detailWasOpened = true;
      handlers({ stopPropagation: () => {}, preventDefault: () => {}},concept,"detail");
    }
  }

  componentDidMount() {
    this.openDetailIfHighlighted();
  }

  componentDidUpdate(prevProps) {
    const prevIRI = prevProps.concept?.IRI?.value;
    const currentIRI = this.props.concept?.IRI?.value;

    const prevHighlight = prevProps.highlight;
    const currentHighlight = this.props.highlight;

    if (prevIRI !== currentIRI || prevHighlight !== currentHighlight) {
      this.openDetailIfHighlighted();
    }
  }

  render(){
    const {hideStatistics, concept, handlers, operation, highlight} = this.props; 
    const isHighlighted = isConceptHighlighted(concept, highlight);
    return (
      <div onClick={e => e.stopPropagation()}>
        <span style={isHighlighted ? { backgroundColor: "#fff3cd", padding: "2px 4px", borderRadius: 4, fontWeight: 600}: undefined}>
          <a
            href={`#/subject/${encodeURIComponent(concept.IRI.value || "")}`}
            target="_blank"
            rel="noopener noreferrer"
            title={i18n.t('components.skos.conceptSmall.details')}
          >
            {concept.Label.value}
          </a>
        </span>&nbsp;{!hideStatistics &&<ConceptCount IRI={concept.IRI.value} concept={concept} handlers={(e)=> handlers(e, concept, "used")} />}&nbsp;
        {/* <Button icon={<InfoOutlined style={{ padding: "0 0 0 0"}} />} shape="circle" size="small" 
          onClick={(e)=>handlers(e, concept, "detail")} /> */}
        {operation == "edit" && 
          <>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.deleteConcept')}>
              <Button type="dashed" size="small" icon={<MinusCircleOutlined />} 
                onClick={(e)=> handlers(e, concept, "delete")}
                style={{"float":"right"}}/>
            </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.unlinkConcept')}>
              <Button type="dashed" size="small" icon={<DisconnectOutlined />} 
                onClick={(e)=> handlers(e, concept, "unlink")}
                style={{"float":"right"}}/>
            </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.replaceWithConcept')}>
              <Button type="dashed" size="small" icon={<RetweetOutlined />} 
                onClick={(e)=> handlers(e, concept, "replacement")}
                style={{"float":"right"}}/>
            </Tooltip>
            <Tooltip placement="top" title={i18n.t('components.skos.conceptSmall.editConcept')}>
              <Button type="dashed" size="small" icon={<EditOutlined />} 
                onClick={(e)=> handlers(e, concept, "edit")}
                style={{"float":"right"}}/>
            </Tooltip>
          </>
        }
      </div>
    )    
  };
}

export const ConceptPanel = connect(
    (state, props) => {
      const { vset } = state;
      const {lang, graph} = props;
      return {
          lang: (lang)?lang: vset.lang,
          graph: (graph)?graph: vset.graph,
      };
    }
  )(ConceptPanelBase);
